var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
// helpers
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import Loader from "@frameworks/shared-library/components/Loader";
import actions from "../../../../redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import TooltipWrapper from "@frameworks/NCD/Components/Tooltip/TooltipWrapper";
var CxoSearch = function (_a) {
    var _b, _c, _d, _e;
    var onSelectClient = _a.onSelectClient;
    var inputRef = useRef(null);
    var dropdownRef = useRef(null);
    var _f = __read(useState(false), 2), searchPopup = _f[0], setSearchPopup = _f[1];
    var _g = __read(useState(""), 2), searchText = _g[0], setSearchText = _g[1];
    var _h = __read(useState(false), 2), isSearchFocused = _h[0], setIsSearchFocused = _h[1];
    var _j = __read(useState(false), 2), loading = _j[0], setLoading = _j[1];
    var _k = __read(useState(null), 2), selectData = _k[0], setSelectData = _k[1];
    var cActions = new actions();
    var empPartnerDetails = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).empPartnerDetails;
    var selectedClientDetails = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).selectedClientDetails;
    var seletedClientOwner = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).seletedClientOwner;
    var handleOnchangeSearch = function (e) {
        var inputValue = e.target.value;
        setSearchText(inputValue);
        if (inputValue.length < 3) {
            return;
        }
        setSearchPopup(true);
        setSearchText(inputValue);
        debounce(function () { return getPartnerSearchData(inputValue, false); });
    };
    useEffect(function () {
        if (isSearchFocused) {
            setSelectData("");
        }
        else {
            setSelectData(seletedClientOwner === null || seletedClientOwner === void 0 ? void 0 : seletedClientOwner.display_name);
        }
    }, [isSearchFocused]);
    useEffect(function () {
        if (selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.client_owner_name) {
            debounce(function () {
                getPartnerSearchData(selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.client_owner_name, true);
            });
        }
    }, [selectedClientDetails === null || selectedClientDetails === void 0 ? void 0 : selectedClientDetails.client_owner_name]);
    var getPartnerSearchData = function (searchText, client) {
        setLoading(true);
        otcDi.transactionJourney
            .getEmpPartnerDetails({
            searchkey: searchText,
            page: 1,
            pageSize: 100,
            orderBy: "",
            orderByDesc: false,
            searchfor: "E",
        })
            .then(function (response) {
            var _a, _b, _c;
            if (client) {
                cActions.updateClientowner((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a[0]);
                setSelectData((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.display_name);
            }
            setLoading(false);
        })
            .catch(function (error) {
            setLoading(false);
        });
    };
    // Close popup on clicking outside
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                inputRef.current !== event.target) {
                setIsSearchFocused(false);
                setSearchPopup(false);
                setSearchText("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var onClearSearch = function () {
        setSearchText("");
        setSearchPopup(false);
        setIsSearchFocused(false);
    };
    var onSelectClientItem = function (item) {
        onSelectClient(item);
        setSearchText("");
        setIsSearchFocused(false);
    };
    var onFocus = function () {
        setSelectData("");
        setIsSearchFocused(true);
    };
    return (React.createElement("div", { className: "position-relative mt-3", ref: dropdownRef },
        React.createElement("div", { className: "d-flex align-items-center mb-2 gap-1 remove-btn-props" },
            React.createElement("label", { className: "ai-label DMSanN_14_400 txt_blackOne1" }, "Login for"),
            React.createElement(TooltipWrapper, { content: "The order will be recorded on behalf RM or Partner", containerId: document.getElementById("cxo-tooltip"), textTruncate: true, parentClassName: "cxo-tooltip" },
                React.createElement("div", { className: "edel-icon-Information txt_secondary-gray d-flex cursor-pointer ", id: "cxo-tooltip" }))),
        React.createElement(Form, { style: { paddingBlock: 7 }, className: "common-search ".concat(isSearchFocused && "active-input", " d-flex align-items-center position-relative") },
            React.createElement("div", { className: "search-input-icons-container d-flex align-items-center w-100 h-24" },
                React.createElement("input", { className: "DMSanN_14_400 txt_blue-tint d-flex bg-transparent w-100 h-100", type: "search", value: searchText || selectData, placeholder: "Search", "aria-label": "Search", onChange: handleOnchangeSearch, onFocus: onFocus, ref: inputRef }),
                isSearchFocused && (searchText || selectData) && (React.createElement("span", { className: "edel-icon-close cross-icon hand_cursor", onClick: onClearSearch })))),
        isSearchFocused && searchText && (React.createElement("div", { className: "client-popup-emp-search header px-0 position-absolute bg_white overflow-x-hidden d-flex flex-column" }, searchText &&
            searchPopup &&
            (loading ? (React.createElement("div", { className: "mt-5 mb-5" },
                React.createElement(Loader, null))) : (React.createElement("div", null,
                ((_b = empPartnerDetails === null || empPartnerDetails === void 0 ? void 0 : empPartnerDetails.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement("p", { className: "DMSans_13_500 not-found mx-2" }, "".concat((_c = empPartnerDetails === null || empPartnerDetails === void 0 ? void 0 : empPartnerDetails.data) === null || _c === void 0 ? void 0 : _c.length, " ").concat(((_d = empPartnerDetails === null || empPartnerDetails === void 0 ? void 0 : empPartnerDetails.data) === null || _d === void 0 ? void 0 : _d.length) > 1 ? "results" : "result", " found"))),
                ((_e = empPartnerDetails === null || empPartnerDetails === void 0 ? void 0 : empPartnerDetails.data) === null || _e === void 0 ? void 0 : _e.length) > 0 ? (empPartnerDetails === null || empPartnerDetails === void 0 ? void 0 : empPartnerDetails.data.map(function (item, index) { return (React.createElement("div", { className: "px-2 py-2 DMSans_13_500 cursor-pointer", onClick: function () {
                        onSelectClientItem(item);
                    }, key: "".concat(item.display_code, "-").concat(index) }, item.display_name)); })) : (React.createElement("p", { className: "DMSans_13_500 not-found mx-2" }, "No result found")))))))));
};
export default CxoSearch;
